import React from 'react';

const testIds = {
    EXIT_FULL_SCREEN_ICON: 'EXIT_FULL_SCREEN_ICON'
};

const ExitFullscreenIcon = (props: any) => (
    <svg
        data-test-id={testIds.EXIT_FULL_SCREEN_ICON}
        {...props}
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.5 9L9 9L9 1.5L6.3 1.5L6.3 6.3L1.5 6.3L1.5 9Z"
            fill="#F9FAFA"
        />
        <path
            d="M22.5 15L15 15L15 22.5L17.7 22.5L17.7 17.7L22.5 17.7L22.5 15Z"
            fill="#F9FAFA"
        />
        <path
            d="M9 22.5L9 15L1.5 15L1.5 17.7L6.3 17.7L6.3 22.5L9 22.5Z"
            fill="#F9FAFA"
        />
        <path
            d="M15 1.5L15 9L22.5 9L22.5 6.3L17.7 6.3L17.7 1.5L15 1.5Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {ExitFullscreenIcon};
